import { SUCCESS, APP_NAME, DANGER } from 'utils/constants/notifyTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { store } from 'react-notifications-component';
import { studentReducerTypes, studentSingleReducerTypes } from 'types';

import { commonApiTypes } from 'types/common';

import { getToaster } from 'utils/helpers/toast';

import { studentDataUpdateState, studentDataState, studentDataSingleState } from './studentState';

const studentDataUpdateSlice = createSlice({
    name: 'studentDataUpdateSlice',
    initialState: studentDataUpdateState,
    reducers: {
        studentDataUpdateStart: (state, action: PayloadAction<studentReducerTypes.IStudentDataUpdateForm>) => {
            return {
                ...state,
                ...action.payload,
                isLoading: true,
            };
        },
        studentDataUpdateSuccess: (state, action: PayloadAction<studentReducerTypes.IStudentDataUpdateSuccess>) => {
            store.addNotification(getToaster(`${APP_NAME} Student`, action.payload.message, SUCCESS));
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isStudentDataUpdate: true,
            };
        },
        studentDataUpdateFailed: (state, action: PayloadAction<commonApiTypes.IApiFailed>) => {
            store.addNotification(getToaster(`${APP_NAME} Student`, action.payload.error, DANGER));
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isStudentDataUpdate: false,
            };
        },
        studentDataUpdateReset: () => {
            return {
                ...studentDataUpdateState,
            };
        },
    },
});

const studentDataSlice = createSlice({
    name: 'studentDataSlice',
    initialState: studentDataState,
    reducers: {
        studentDataStart: (state, action: PayloadAction<studentReducerTypes.IStudentDataForm>) => {
            return {
                ...state,
                ...action.payload,
                isLoading: true,
            };
        },
        studentDataSuccess: (state, action: PayloadAction<studentReducerTypes.IStudentDataSuccess>) => {
            return {
                ...state,
                current_page: action.payload.current_page,
                total: action.payload.total,
                last_page: action.payload.last_page,
                to: action.payload.to,
                data: action.payload.data,
                isLoading: false,
                isStudentData: true,
            };
        },
        studentDataFailed: (state, action: PayloadAction<commonApiTypes.IApiFailed>) => {
            store.addNotification(getToaster(`${APP_NAME} student`, action.payload.error, DANGER));
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isStudentData: false,
            };
        },
        studentDataReset: () => {
            return {
                ...studentDataState,
            };
        },
    },
});

const studentDataSingleSlice = createSlice({
    name: 'studentDataSingleSlice',
    initialState: studentDataSingleState,
    reducers: {
        studentDataSingleStart: (state, action: PayloadAction<studentSingleReducerTypes.IStudentDataSingleForm>) => {
            return {
                ...state,
                ...action.payload,
                isLoading: true,
            };
        },
        studentDataSingleSuccess: (
            state,
            action: PayloadAction<studentSingleReducerTypes.IStudentDataSingleSuccess>
        ) => {
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isStudentDataSingle: true,
            };
        },
        studentDataSingleFailed: (state, action: PayloadAction<commonApiTypes.IApiFailed>) => {
            store.addNotification(getToaster(`${APP_NAME} student`, action.payload.error, DANGER));
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isStudentDataSingle: false,
            };
        },
        studentDataSingleReset: () => {
            return {
                ...studentDataSingleState,
            };
        },
    },
});

export { studentDataUpdateSlice, studentDataSlice, studentDataSingleSlice };
